import script from "./ConsoleView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConsoleView.vue?vue&type=script&lang=ts&setup=true"

import "./ConsoleView.vue?vue&type=style&index=0&id=721f0646&lang=scss"

const __exports__ = script;

export default __exports__